import { feedbackAxios } from "@/declare/api/axios";
import { FeedbackReply, UserFeedback } from "@/declare/interface/feedback/user-feedback";
import { AxiosResponse } from "axios";
import qs from "qs";


export function getUserFeedbacks(params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/user-feedbacks`, {
        params: { ...params }
    })
}

export function createUserFeedback(data: UserFeedback, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/user-feedbacks`, data, {
        params: params
    })
}

export function updateUserFeedback(UserFeedbackId: number, data: UserFeedback, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.put(`/user-feedbacks/${UserFeedbackId}`, data, {
        params: params
    })
}

export function deleteUserFeedbacks(UserFeedbackIds: number[], params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/user-feedbacks/delete-multi`, UserFeedbackIds, {
        params: params
    })
}

export function getFeedbackFileUrl(objectName: string, bucketName: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/objects/url`, {
        params: {
            objectName: `${objectName}`,
            bucketName: `${bucketName}`,
            ...params,
        }
    })
}

export function checkFeedbackFileExists(md5: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/files/exists/${md5}`, {
        params: params,
    })
}

export function getFeedbackPresignedPutObjectUrl(objectName: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        },
    })
}

/**
 * 获得已响应的数量
 * 获得当前已响应但还未验证的反馈数量，用于用户提醒
 */
export function getPendingVerificationCount(projectId: number, userName: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/user-feedbacks/pending-verification/count`, {
        params: {
            projectId,
            userName,
        },
    })
}

/**
  * 查询反馈详情
  * 查询反馈基本信息，包括回复记录
  **/
export function getUserFeedbackDetail(id: number, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/user-feedbacks/${id}`, {
        params: params,
    })
}

/**
 * 回复
 **/
export function createFeedbackReply(data: FeedbackReply, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/feedback-replies`, data, {
        params: params
    })
}

/**
 * 批量回复
 **/
export function replyMultiFeedback(feedbackIds: number[], reply: FeedbackReply, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/feedbacks/multi-reply`, reply, {
        params: {
            feedbackIds: feedbackIds,
        }, paramsSerializer: params => {
            return qs.stringify(params, { arrayFormat: 'comma' })
        }
    })
}

/**
 * 批量更新状态
 * @param ids 
 * @param params 
 * @returns 
 */
export function multiUpdateFeedbackStatus(ids: number[], status: number, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.post(`/feedbacks/status`, ids, {
        params: {
            status
        }
    })
}

/**
 * 查询项目的功能点列表
 * 根据项目、检索词查询功能点列表
 **/
export function getFunctionPointsByKeyword(projectId: number, keyword: string, params?: {}): Promise<AxiosResponse<any>> {
    return feedbackAxios.get(`/functions/by-key-word`, {
        params: {
            projectId,
            keyword,
        },
    })
}